<div class="vh-100 d-flex">
    <app-sidebar class="h-100 sidebar-wrapper bg-body-secondary"></app-sidebar>
    <div class="h-100 flex-grow-1 bg-body">
        <router-outlet></router-outlet>
    </div>
</div>